'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _compose = require('recompose/compose');

var _compose2 = _interopRequireDefault(_compose);

var _enterScope = require('./enterScope');

var _enterScope2 = _interopRequireDefault(_enterScope);

var _leaveScope = require('./leaveScope');

var _leaveScope2 = _interopRequireDefault(_leaveScope);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function composeWithScope() {
  for (var _len = arguments.length, hocs = Array(_len), _key = 0; _key < _len; _key++) {
    hocs[_key] = arguments[_key];
  }

  return _compose2.default.apply(undefined, [_enterScope2.default].concat(hocs, [_leaveScope2.default]));
}

exports.default = composeWithScope;


//////////////////
// WEBPACK FOOTER
// ./~/recompose-scope/composeWithScope.js
// module id = 480
// module chunks = 0